import { Injectable } from "@angular/core";
import {
  Router,
  RouterStateSnapshot,
  CanActivateChild,
  ActivatedRouteSnapshot,
} from "@angular/router";
import { AuthenticationService } from "../authentication.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuardService implements CanActivateChild {
  constructor(public auth: AuthenticationService, public router: Router) {}

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const isAdmin = state.url.startsWith("/admin");
    let userProfile = this.auth.getProfile();

    if (!this.auth.isAuthenticated() || userProfile.isAdmin !== isAdmin) {
      this.auth.setRedirectUrl(state.url !== "/" ? state.url : null);
      this.router.navigate(["login"]);
      return false;
    }
    return true;
  }
}
